import { render, staticRenderFns } from "./RedeemableEntitlement.vue?vue&type=template&id=19f564d8&scoped=true&"
import script from "./RedeemableEntitlement.vue?vue&type=script&lang=js&"
export * from "./RedeemableEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./RedeemableEntitlement.vue?vue&type=style&index=0&id=19f564d8&prod&lang=scss&scoped=true&"
import style1 from "./RedeemableEntitlement.vue?vue&type=style&index=1&id=19f564d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f564d8",
  null
  
)

export default component.exports